(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-icon-item"] && !Shopify.designMode) return;
  try {
    const ICON_SVG_SELECTOR = '.product-description__desc-icon-img';
  const ICON_LIST_SELECTOR = '.product-description__desc-icons';
  const iconSvgCache = new Map();
  let iconSvgUid = 0;

  /* Keys are normalized brand names (lowercase, no accents/spaces/symbols). */
  const BRAND_ICON_COLORS = {
    kabamakeup: '#EA68A6',
    kaba: '#802855',
    dluchi: '#00ABA6',
    dlunchi: '#00ABA6',
    lareceta: '#223B12',
    omg: '#8A1A9B'
  };

  function normalizeBrand(value) {
    return (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function matchBrandColor(value) {
    const key = normalizeBrand(value);
    if (!key) return null;
    if (BRAND_ICON_COLORS[key]) return BRAND_ICON_COLORS[key];
    /* Longest brand first so "Kaba Makeup ..." wins over "Kaba ...". */
    const brand = Object.keys(BRAND_ICON_COLORS)
      .sort((a, b) => b.length - a.length)
      .find((name) => key.startsWith(name));
    return brand ? BRAND_ICON_COLORS[brand] : null;
  }

  function getBrandIconColor() {
    const link = document.querySelectorAll('.breadcrumbs__link')[1];
    if (!link) return null;
    let handle = '';
    try {
      handle = new URL(link.href, window.location.href).pathname.split('/').filter(Boolean).pop() || '';
    } catch (error) {}
    return matchBrandColor(link.textContent) || matchBrandColor(handle);
  }

  /* Point every painted fill/stroke at currentColor so the brand color drives the icon. White stays as a detail color. */
  const KEEP_PAINT = /^(none|transparent|currentcolor|inherit|#fff|#ffffff|white|url\(.*\))$/i;

  function recolorPaint(value) {
    const paint = value.trim();
    return !paint || KEEP_PAINT.test(paint) ? value : 'currentColor';
  }

  function recolorSvg(svg) {
    [svg, ...svg.querySelectorAll('*')].forEach((node) => {
      ['fill', 'stroke'].forEach((attr) => {
        if (node.hasAttribute(attr)) node.setAttribute(attr, recolorPaint(node.getAttribute(attr)));
      });
      const style = node.getAttribute('style');
      if (style) {
        node.setAttribute(
          'style',
          style.replace(/(^|;)\s*(fill|stroke)\s*:\s*([^;]+)/gi, (match, sep, prop, value) =>
            `${sep}${prop}:${recolorPaint(value)}`
          )
        );
      }
      if (node.tagName.toLowerCase() === 'style' && node.textContent) {
        node.textContent = node.textContent.replace(/(fill|stroke)\s*:\s*([^;}]+)/gi, (match, prop, value) =>
          `${prop}:${recolorPaint(value)}`
        );
      }
    });
    /* Shapes with no paint at all default to black: give them the brand color too. */
    if (!svg.hasAttribute('fill')) svg.setAttribute('fill', 'currentColor');
  }

  function isSvgUrl(url) {
    try {
      return new URL(url, window.location.href).pathname.toLowerCase().endsWith('.svg');
    } catch (error) {
      return false;
    }
  }

  function fetchIconSvg(url) {
    if (!iconSvgCache.has(url)) {
      const request = fetch(url, { mode: 'cors', credentials: 'omit' })
        .then((response) => {
          if (!response.ok) throw new Error(`SVG request failed: ${response.status}`);
          return response.text();
        })
        .catch((error) => {
          iconSvgCache.delete(url);
          throw error;
        });
      iconSvgCache.set(url, request);
    }
    return iconSvgCache.get(url);
  }

  function sanitizeSvg(svg) {
    svg.querySelectorAll('script, foreignObject').forEach((node) => node.remove());
    [svg, ...svg.querySelectorAll('*')].forEach((node) => {
      Array.from(node.attributes).forEach((attr) => {
        const name = attr.name.toLowerCase();
        const value = attr.value.trim().toLowerCase();
        if (name.startsWith('on')) node.removeAttribute(attr.name);
        if ((name === 'href' || name === 'xlink:href') && value.startsWith('javascript:')) {
          node.removeAttribute(attr.name);
        }
      });
    });
  }

  /* Prefix ids so several copies of the same SVG don't share gradients/clip paths. */
  function scopeSvgIds(svg) {
    const prefix = `icon-svg-${++iconSvgUid}-`;
    const nodes = svg.querySelectorAll('[id]');
    if (!nodes.length) return;

    const ids = new Set();
    nodes.forEach((node) => {
      ids.add(node.id);
      node.id = prefix + node.id;
    });

    const rewrite = (value) =>
      value
        .replace(/url\(\s*(['"]?)#([^'")\s]+)\1\s*\)/g, (match, quote, id) =>
          ids.has(id) ? `url(#${prefix}${id})` : match
        )
        .replace(/^#(.+)$/, (match, id) => (ids.has(id) ? `#${prefix}${id}` : match));

    [svg, ...svg.querySelectorAll('*')].forEach((node) => {
      Array.from(node.attributes).forEach((attr) => {
        if (attr.name === 'id') return;
        const next = rewrite(attr.value);
        if (next !== attr.value) node.setAttribute(attr.name, next);
      });
      if (node.tagName.toLowerCase() === 'style' && node.textContent) {
        node.textContent = node.textContent.replace(/#([\w-]+)/g, (match, id) =>
          ids.has(id) ? `#${prefix}${id}` : match
        );
      }
    });
  }

  function inlineIconSvg(img) {
    if (img.dataset.inlineSvgState) return;
    const url = img.currentSrc || img.getAttribute('src');
    if (!url || !(img.hasAttribute('data-inline-svg') || isSvgUrl(url))) return;
    img.dataset.inlineSvgState = 'loading';

    fetchIconSvg(url)
      .then((markup) => {
        const doc = new DOMParser().parseFromString(markup, 'image/svg+xml');
        const svg = doc.documentElement;
        if (!svg || svg.nodeName.toLowerCase() !== 'svg' || doc.querySelector('parsererror')) {
          throw new Error('Response is not a valid SVG');
        }

        sanitizeSvg(svg);
        scopeSvgIds(svg);
        recolorSvg(svg);

        if (!svg.hasAttribute('viewBox')) {
          const width = parseFloat(svg.getAttribute('width'));
          const height = parseFloat(svg.getAttribute('height'));
          if (width && height) svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
        }
        svg.removeAttribute('width');
        svg.removeAttribute('height');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        svg.setAttribute('focusable', 'false');
        svg.classList.add('product-description__desc-icon-svg');

        const label = img.getAttribute('alt');
        if (label) {
          svg.setAttribute('role', 'img');
          svg.setAttribute('aria-label', label);
        } else {
          svg.setAttribute('aria-hidden', 'true');
        }

        img.replaceWith(document.importNode(svg, true));
      })
      .catch(() => {
        /* Keep the <img> fallback when the file can't be fetched (CORS, 404, invalid markup). */
        img.dataset.inlineSvgState = 'failed';
      });
  }

  function initIconSvgs(root) {
    const brandColor = getBrandIconColor();
    if (brandColor) {
      root.querySelectorAll(ICON_LIST_SELECTOR).forEach((list) => {
        list.style.setProperty('--icon-brand-color', brandColor);
      });
    }
    root.querySelectorAll(ICON_SVG_SELECTOR).forEach(inlineIconSvg);
  }

  initIconSvgs(document);
  document.addEventListener('shopify:section:load', (event) => initIconSvgs(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rebuy-link-follow"] && !Shopify.designMode) return;
  try {
    (function () {
    var rebuyScope = '[class*="rebuy"], [id*="rebuy"]';
    var storeHost = window.location.hostname.replace(/^www\./, '');

    function isInternal(link) {
      try {
        var url = new URL(link.href, window.location.href);
        return url.hostname.replace(/^www\./, '') === storeHost;
      } catch (error) {
        return false;
      }
    }

    function cleanLink(link) {
      if (!link.relList || !link.relList.contains('nofollow')) return;
      if (!link.closest(rebuyScope) || !isInternal(link)) return;
      link.relList.remove('nofollow');
      if (!link.relList.length) link.removeAttribute('rel');
    }

    function cleanTree(node) {
      if (node.nodeType !== 1) return;
      if (node.matches('a[rel~="nofollow"]')) cleanLink(node);
      node.querySelectorAll('a[rel~="nofollow"]').forEach(cleanLink);
    }

    cleanTree(document.body);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          cleanLink(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(cleanTree);
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['rel']
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
